
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import AdUnit from '@/components/AdUnit.vue';

@Component({
	name: 'TimelineAdUnit',
	components: { AdUnit },
})
export default class TimelineAdUnit extends Vue {
	@Prop() index: number;
	@Prop({ default: 4 }) everyXBuckets: number;
	@Prop({ default: 0 }) firstAdAt: number;
	@Prop({ default: 3 }) capsAt: number;

	get actualAdIndex() {
		if (this.index < this.firstAdAt) return false;

		const i = (this.index - this.firstAdAt) / this.everyXBuckets;
		const isNotFloat = i % 1 === 0;
		const isNotCapped = i < this.capsAt;
		return isNotFloat && isNotCapped ? i + 1 : false;
	}
}
